import React from 'react';
import './styles.css';

function ShowLoading({ loading }) {
  if (loading) {
    return (
      <div id="loader-wrapper">
        <div id="loader" />
      </div>
    );
  } else {
    return <></>
  }
}

export default ShowLoading;
